var _rect, _rect2, _rect3, _line, _rect4, _ellipse, _ellipse2, _rect5, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeCabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 582,
    viewBox: "0 0 428 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.0186,
    y: 31.8281,
    width: 310.097,
    height: 500.156,
    fill: "#984B20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0063,
    y: 537.44,
    width: 397.397,
    height: 44.5594,
    fill: "#984B20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 427.406,
    height: 26.3719,
    fill: "#984B20"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 219.522,
    y1: 31.8281,
    x2: 219.522,
    y2: 531.984,
    stroke: "#55301B",
    strokeWidth: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169.154,
    y: 287,
    width: 18.3193,
    height: 56,
    rx: 4,
    fill: "#E79C2B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.314,
    cy: 315,
    rx: 11.9076,
    ry: 13,
    fill: "#F5C853"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.314,
    cy: 315,
    rx: 9.15966,
    ry: 10,
    fill: "#FFEFC5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 254.339,
    y: 287,
    width: 18.3193,
    height: 56,
    rx: 4,
    fill: "#E79C2B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.498,
    cy: 315,
    rx: 11.9076,
    ry: 13,
    fill: "#F5C853"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.499,
    cy: 315,
    rx: 9.15966,
    ry: 10,
    fill: "#FFEFC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeCabinet);
export default __webpack_public_path__ + "static/media/large_cabinet.59dd26cde19a3d5c9ceee8307739c9c5.svg";
export { ForwardRef as ReactComponent };